<template>
    <div
        :class="{
            'in-preferiti': photo.isFavorite,
            'in-carrello': photo.inCart
        }"
        class="foto card"
    >
        <div class="card-header d-none p-1 border-0">
            <ul class="status-foto mb-0 d-flex flex-row justify-content-end">
                <li class="preferiti d-none m-1 p-1 text-center">
                    <font-awesome-icon :icon="['fas', 'star']" />
                </li>

                <li class="carrello d-none m-1 p-1 text-center">
                    <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                </li>
            </ul>
        </div>

        <a
            href="#"
            @click.prevent="onPhotoClicked"
        >
            <img
                ref="image"
                src="/images/icons/loader.gif"
                :data-src="getUrl(photo.id)"
                class="card-img-top"
                alt
            />
        </a>

        <div
            class="card-footer py-1 w-100"
            v-if="!viewOnly"
        >
            <ul class="azioni-foto d-flex justify-content-around mb-0">
                <li>
                    <a
                        href="#"
                        :class="{active: photo.isFavorite}"
                        @click.prevent="onFavoriteClicked"
                    >
                        <font-awesome-icon :icon="['fas', 'star']" />
                    </a>
                </li>

                <li v-show="isOrderable">
                    <a
                        href="#"
                        :class="{active: photo.inCart}"
                        @click.prevent="onCartClicked"
                    >
                        <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "GalleryPhotoCard",

    props: {
        photo: { type: Object, required: true },
        viewOnly: { type: Boolean, required: false, default: false },
        orderable: { type: Boolean, required: false, default: true }
    },

    data() {
        return {};
    },

    mounted() {
        var that = this;
        setTimeout(function () {
            that.checkLoadImage(that);
        }, 200);
    },

    methods: {
        getUrl(photoId) {
            return this.$imagesService.getUrl(photoId, "event-web", true);
        },

        checkLoadImage(scope) {
            if (scope.photo.loadingAllowed && scope.$refs.image) {
                if (scope.$refs.image.src.endsWith("loader.gif")) {
                    scope.$refs.image.onload = scope.onImageLoaded;
                    scope.$refs.image.src = scope.$refs.image.dataset.src;
                }
            } else {
                setTimeout(scope.checkLoadImage, 500, scope);
            }
        },
        onImageLoaded() {
            this.$emit("loaded");
        },
        onPhotoClicked() {
            this.$emit("photoClicked", this.photo.id);
        },
        onFavoriteClicked() {
            this.$api
                .photoFavoriteToggle(this.photo.id)
                .then((result) => {
                    console.debug("PHOTO_FAVORITE_TOGGLE", result);
                    this.photo.isFavorite = result.isFavorite ? true : false;
                    this.$emit("favoriteToggle", this.photo);
                })
                .catch((error) => {
                    console.error("PHOTO_FAVORITE_TOGGLE:", error);
                });
        },
        onCartClicked() {
            this.$emit("showArticlesModal", this.photo);
        }
    },

    computed: {
        isOrderable() {
            return this.orderable;
        }
    }
};
</script>

<style scoped>
</style>

